import { ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICE_OPTIONS } from "../../data/site";

export const Footer = () => {
  const go = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="bg-[#1A362D] text-[#F9F8F6] pt-24 pb-12 relative overflow-hidden grain">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid md:grid-cols-12 gap-12 border-b border-[#4A5A53]/40 pb-16">
          <div className="md:col-span-6">
            <h2 className="font-serif font-light text-5xl md:text-7xl leading-[1] tracking-tight">
              A calmer home,<br />just a call away.
            </h2>
            <button
              data-testid="footer-book-button"
              onClick={() => go("#book")}
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#C26D5C] text-[#F9F8F6] px-7 py-4 text-sm font-medium hover:bg-[#A85D4E] transition-colors duration-300"
            >
              Request a free quote
              <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
            </button>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm tracking-[0.2em] uppercase text-[#7B8A83] mb-5">Services</p>
            <ul className="space-y-2.5">
              {SERVICE_OPTIONS.slice(0, 6).map((s) => (
                <li key={s}>
                  <button onClick={() => go("#services")} className="text-[#D1DEC9] hover:text-[#F9F8F6] transition-colors duration-200 text-left">{s}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm tracking-[0.2em] uppercase text-[#7B8A83] mb-5">Get in touch</p>
            <ul className="space-y-2.5 text-[#D1DEC9]">
              <li><a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-[#F9F8F6] transition-colors duration-200">{COMPANY.phone}</a></li>
              <li><a href={`mailto:${COMPANY.email}`} className="hover:text-[#F9F8F6] transition-colors duration-200">{COMPANY.email}</a></li>
              <li className="pt-2">{COMPANY.area}</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[#7B8A83]">
          <span className="font-serif text-xl text-[#F9F8F6]">{COMPANY.name}</span>
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <span>ABN registered · Police checked · Insured · Blue Card verified</span>
        </div>
      </div>
    </footer>
  );
};
